
import React, { useContext } from "react";
import { FaMicroscope, FaTrafficLight, FaHeadSideMask, FaFire } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import './AuditGlobal.css';
import BannerImage from './audit_hero.png';

function SafetyAssessment() {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/safety-assessment');
    } else {
      navigate('/login', { state: { from: '/booking/safety-assessment' } });
    }
  };

  return (
    <div className="audit-page">
      <div className="audit-max-width">

        {/* --- HERO --- */}
        <div className="audit-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">Risk Analysis</span>
          <h1 className="hero-title">Safety Assessment</h1>
          <p className="hero-subtitle">
            Proactive hazard identification. Spotting the danger before it becomes a disaster.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Book Assessment <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">Assessment vs. Audit</h2>
              <p className="article-text">
                While an audit checks the *system*, a safety assessment checks the *risk*.
                It is a proactive process used to evaluate specific tasks, machinery, or new processes
                to identify potential hazards before work begins.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">The Assessment Cycle</h2>
              <p className="article-text">
                1. <strong>Identify:</strong> Spotting the hazard (Physical, Chemical, Biological, Ergonomic).<br />
                2. <strong>Evaluate:</strong> determining the likelihood and severity of harm (Risk Matrix).<br />
                3. <strong>Control:</strong> Implementing measures (Elimination -&gt; Substitution -&gt; PPE).<br />
                4. <strong>Review:</strong> Ensuring controls remain effective.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Focus: Specific Hazards</h2>
              <p className="article-text">
                Assessments are often targeted: Fire Risk Assessment (FRA), Job Safety Analysis (JSA),
                PPE Assessment, or Ergonomic Assessment. They are granular and technical.
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">Hazard Types</h4>
              <ul className="key-list">
                <li><FaFire className="check-icon" /> Fire & Explosion</li>
                <li><FaMicroscope className="check-icon" /> Chemical Exposure</li>
                <li><FaTrafficLight className="check-icon" /> Moving Machinery</li>
                <li><FaHeadSideMask className="check-icon" /> Health Hazards</li>
              </ul>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Get Assessed</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                Quantify your risk today.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Book Now
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default SafetyAssessment;
